<div id="ErrorModal" *ngIf="errorMsg" class="modal open" materialize="modal" [materializeParams]="[{dismissible: false}]">
  <div class="modal-content text-left">
    <p [textContent]="errorMsg"></p>

  </div>
  <div class="modal-footer text-right">
    <button type="button" (click)="closeModal()" class="btn btn-flat modal-btn modal-action modal-close waves-effect" [textContent]="'GOT IT'"></button>
  </div>
</div>
<div id="genericModal" *ngIf="modalContent" class="modal open genModal insuranceModal" materialize="modal" [materializeParams]="[{dismissible: false}]">
  <div class="modal-header text-left" *ngIf="modalContent.header">
    <div class="modal-header-title" [innerHTML]="modalContent.header | safeHtml"></div>
    <div class="modal-close-icon" (click)="closeModal()"></div>
  </div>
  <div class="modal-content text-left">
    <div class="row text-left title" *ngIf="modalContent.title" [textContent]="modalContent.title"></div>
    <div class="" *ngIf="modalContent.coveragePoints && modalContent.coveragePoints.length > 0">
      <div class="row margin-top-2rem" *ngFor="let point of modalContent.coveragePoints; let i=index;">
        <div class="col l3 m3 s4 no-padding valign-wrapper step-icon copy-icon">
          <img [src]="s3BucketUrl + '/insurance-coverage-details/icons/' + point.image" [alt]="point.featureTitle"/>
        </div>
        <div class="col l9 m9 s8 no-padding">
          <p class="question">{{i+1}}. {{point.featureTitle}}</p>
          <p class="answer" [innerHTML]="point.featureContent | safeHtml"></p>
        </div>
      </div>
    </div>
    <div class="row text-left modalFooter" *ngIf="modalContent.footerText['tnc'] && modalContent.footerText['tnc'].length > 0">
      <div *ngFor="let tc of modalContent.footerText.tnc" class="lists-styles">
        <ul class="list-style">
          <li>
            <span [class.hidePercent]="insuranceFeePercentage === 0" [innerHTML]="(tc.split('{amount}').join(insuranceAmount).replace('{percent}',insuranceFeePercentage)) | safeHtml"></span>
          </li>
        </ul>
      </div>
    </div>
    <div class="row text-left modalFooter" *ngIf="modalContent.footerText['consent']">
      <div *ngIf="modalContent.footerText.footerContent.footerTitle.visible.payment">
        <div class="footerContent" *ngFor="let context of modalContent.footerText.footerContent.footerTitle['text'];let i=index">
          <span [class.hidePercent]="insuranceFeePercentage === 0" [innerHTML]="(context.replace('{amount}',insuranceAmount).replace('{percent}',insuranceFeePercentage)) | safeHtml"></span>
          <a class="clk-content" *ngIf="(modalContent.footerText['document']['fileLocation']) && (i!==0)"
          (click)="downloadFile(modalContent.footerText['document'])">click here</a>
        </div>
      </div>
      <input id="mycheckbox_1" name="mycheckbox_1" type="checkbox" [(ngModel)]="insuranceCheck" (ngModelChange)="consentCheck()" class="filled-in"/>
      <label for="mycheckbox_1" class="checkbox-label">
        <span class="consent-content" [innerHTML]="modalContent.footerText['consent'] | safeHtml"></span>
      </label>
      <span *ngIf="modalContent.footerText['document']['fileLocation']"></span>
      <a class="clk-content" *ngIf="modalContent.footerText['document']['fileLocation'] && modalContent.footerText['tncLable']" (click)="downloadFile(modalContent.footerText['document'])" [textContent]="modalContent.footerText['tncLable']"></a>.
    </div>
  </div>
</div>
<div class="modal-overlay kyc-modal-overlay"></div>
